import * as mutationsType from './mutationsType'

export default {
  //保存用户信息
  [mutationsType.RECEIVE_USER_INFO] (state, { userInfo }) {
    state.userInfo = userInfo
  },
}
